import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import CardTitle from "@saleor/components/CardTitle";
import {
  DeliveryTypeEnum,
  SmopOrderStatusEnum
} from "@saleor/types/globalTypes";
import { DeliveryTypeEnum as DelEnum } from "@saleor/types/globalTypes";
import { generatePdf } from "@saleor/utils/pdf/handler";
import classNames from "classnames";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../../misc";
import { OrderDetails_order } from "../../types/OrderDetails";

const useStyles = makeStyles(
  theme => ({
    buttonShipping: {
      "&:hover": {
        backgroundColor: "#f5f5f5 !important"
      },
      background: "#FFFFFF !important",
      border: "1px solid #E5E5E5 !important"
    },
    buttonShippingDisable: {
      background: "#EFF5F8  !important",
      border: "1px solid #E5E5E5 !important"
    },
    buttonShippingLabel: {
      color: "#3D3D3D"
    },
    disabled: {
      opacity: "0.5",
      pointerEvents: "none"
    },
    printShippingLabelHeader: {
      [theme.breakpoints.down("lg")]: {
        fontSize: "14px"
      }
    },
    root: {
      ...theme.typography.body1,
      lineHeight: 1.9,
      width: "100%"
    },
    textBold: {
      fontSize: "14px",
      fontWeight: 600,
      textAlign: "left"
    },
    textRight: {
      fontSize: "14px",
      textAlign: "left"
    }
  }),
  { name: "OrderPrintShippingLabel" }
);

export interface OrderPrintShippingLabelProps {
  order: OrderDetails_order;
  generateDialog: any;
  disableAction: boolean;
}

const OrderPrintShippingLabel: React.FC<OrderPrintShippingLabelProps> = props => {
  const { order, generateDialog, disableAction } = props;
  const classes = useStyles(props);
  const intl = useIntl();

  const handlePrintLabel = () => {
    const deliveryType = order?.shippingMethod?.deliveryType;
    const isNationwide = deliveryType === DeliveryTypeEnum.NATIONWIDE_DELIVERY;

    const endpoint = isNationwide
      ? "/generate-nationwide-shipping-label"
      : "/generate-shipping-label";
    generatePdf({ order }, endpoint);
  };

  return (
    <Card>
      <CardTitle
        customId="txtAdminFulfillmentMotherOrderDetailsPageShippingLabel"
        title={intl.formatMessage({
          defaultMessage: "Shipping Label",
          description: "section header"
        })}
        toolbar={
          <>
            {((maybe(() => order.shippingMethod.deliveryType) ===
              DelEnum.EXPRESS ||
              maybe(() => order.shippingMethod.deliveryType) ===
                DelEnum.EXPRESS_LONG_DISTANCE) &&
              maybe(() => order.smopStatus) !== SmopOrderStatusEnum.SHIPPED &&
              maybe(() => order.smopStatus) !==
                SmopOrderStatusEnum.COMPLETED) ||
            ((maybe(() => order.shippingMethod.deliveryType) ===
              DeliveryTypeEnum.NEXT_DAY ||
              maybe(() => order.shippingMethod.deliveryType) ===
                DeliveryTypeEnum.NATIONWIDE_DELIVERY) &&
              (maybe(() => order.smopStatus) === SmopOrderStatusEnum.PACKED ||
                maybe(() => order.smopStatus) ===
                  SmopOrderStatusEnum.READY_TO_SHIP)) ? (
              <Button
                id="btnAdminFulfillmentMotherOrderDetailsPageGenerate"
                color="primary"
                onClick={() => generateDialog()}
                disabled={disableAction}
              >
                <span
                  id="txtAdminFulfillmentMotherOrderDetailsPageGenerate"
                  className={disableAction ? classes.disabled : null}
                >
                  Generate
                </span>
              </Button>
            ) : null}
          </>
        }
      />
      <CardContent id="cmpAdminFulfillmentMotherOrderDetailsPageCardContent">
        <Button
          id="btnAdminFulfillmentMotherOrderDetailsPagePrint"
          fullWidth
          variant="contained"
          color="default"
          className={classNames({
            [classes.buttonShipping]: order !== null,
            [classes.buttonShippingDisable]:
              order === null || order === undefined
          })}
          onClick={handlePrintLabel}
          disabled={order ? false : true}
        >
          <span
            id="txtAdminFulfillmentMotherOrderDetailsPagePrint"
            className={classes.buttonShippingLabel}
          >
            PRINT
          </span>
        </Button>
      </CardContent>
    </Card>
  );
};

OrderPrintShippingLabel.displayName = "OrderPrintShippingLabel";
export default OrderPrintShippingLabel;
